<template>
    <div>
        <h2 class="mb-3 text-center text-md-start">Search</h2>
        <BRow class="d-flex justify-content-between search__input">
            <BForm>
                <div class="search__inputDiv d-flex align-items-center">
                    <input id="keyboardTextField" v-model="searchInput" type="text"
                        placeholder="Search for a person" class="search__inputDiv-input" />
                    <button class="search__inputDiv-btn">
                        <i class="fa fa-search"></i>
                        Find
                    </button>
                </div>
            </BForm>
        </BRow>

        <KeyBoardUI v-if="keyboardValue && isTouchable" @onChange="onKeyboardChange" @onKeyPress="onKeyPress" :input="searchInput" />
        <div @click="keyBoardToggle(false)">
            <BRow class="mt-5">
                <BCol lg="8">
                    <template v-if="paginatedResults.length">
                        <div v-for="(person, index) in paginatedResults" :key="index">
                            <PersonCard :id="person.id" :name="person?.name" :position="person?.extra"
                                v-memo="[person.id]" :company="person.companyName" :avatar="person?.image"
                                :companyLogo="company01" :singleUserData="singleUserData" :selected="selected" />
                        </div>
                        <div class="pagination-controls mt-3 d-flex gap-3 justify-content-center align-items-center">
                            <button class="mx-0" :disabled="currentPage === 1" @click="currentPage--">Previous</button>
                            <span>Page {{ currentPage }} of {{ totalPages }}</span>
                            <button :disabled="currentPage === totalPages" @click="currentPage++">Next</button>
                        </div>
                    </template>
                    <template v-if="searchInput && !paginatedResults.length">
                        <p class="text-center">No results found</p>
                    </template>
                </BCol>

                <BCol lg="4" v-if="searchInput">
                    <div class="text-muted mb-3">
                        <i class="fa fa-filter"></i>
                        <span class="text-muted mx-2">Filter By</span>
                    </div>
                    <div>
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <p class="fw-bold mb-0">{{ title }}</p>
                            <i class="fa fa-chevron-right"></i>
                        </div>
                        <BCard class="border border-0 filterCard shadow-lg py-3 px-2">
                            <div class="d-block justify-content-between">
                                <div v-for="(filter, index) in this.golfClubData
                                    .awards" :key="index">
                                    <FilterCard :name="filter.name" @change="checkfunc" :length="filter.persons.length"
                                        :selectedCheckBox="selectedCheckBox" />
                                </div>
                            </div>
                        </BCard>
                    </div>
                    <div>
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <p class="fw-bold mb-0">{{ titleDate }}</p>
                            <i class="fa fa-chevron-right"></i>
                        </div>
                        <BCard class="border border-0 filterCard shadow-lg py-3 px-2">
                            <div class="d-block justify-content-between">
                                <div v-for="(filter, index) in calculateDateRanges" :key="index">
                                    <FilterCard :name="filter.start" :end="filter.end"
                                        :selectedCheckBox="selectedCheckDateBox" :length="filter.person"
                                        @change="checkDatefunc" />
                                </div>
                            </div>
                        </BCard>
                    </div>
                </BCol>
            </BRow>
            <BRow class="row mx-2 mx-lg-5 mb-4" v-if="searchInput.length == 0">
                <BCol lg="12">
                    <AwardsListCarousel/>
                </BCol>
            </BRow>
        </div>

        <b-modal v-model="openModal" size="lg" hide-header hide-footer class="winnerAward-modal" no-fade :centered="true"
            v-cloak @hidden="onModalHidden">
            <div class="position-relative" @click="toggle">
                <div class="winnerAward-modal__close">
                    <img :src="closeImg" />
                </div>
            </div>

            <BRow>
                <BCol sm="12">
                    <AwardedPersonInformation :personData="this.selectedPersonData" :toggle="toggle" />
                </BCol>
            </BRow>
        </b-modal>
    </div>
</template>

<script>
    import { debounce } from 'lodash';
    import PersonCard from "@/components/PersonCard.vue";
    import FilterCard from "@/components/FilterCard.vue";
    import CommunityCard from "@/components/CommunityCard.vue";
    import SearchSponsorCard from "@/components/SearchSponsorCard.vue";
    import RecentWinners from "@/components/RecentWinners.vue";
    import close from "../assets/svgs/close.svg";
    import KeyBoardUI from "../components/KeyBoardUI.vue";
    import company01 from "@/assets/svgs/ecliansen.svg";
    import AwardedPersonInformation from "@/components/AwardedPersonInformation.vue";
    import AwardsListCarousel from "@/components/AwardsListCarousel.vue";

    export default {
        components: {
            PersonCard,
            FilterCard,
            CommunityCard,
            RecentWinners,
            KeyBoardUI,
            SearchSponsorCard,
            AwardedPersonInformation,
            AwardsListCarousel,
        },

        data() {
            return {
                selected: "",
                closeImg: close,
                personDetail: this.golfClubData?.key_persons,
                openModal: false,
                selectedPersonData: {},
                searchInput: "",
                currentPage: 1,
                pageSize: 20,
                title: "Award Type",
                titleDate: "Date",
                company01: company01,
                value: false,
                dataRange: [],
                selectedCheckBox: [],
                selectedCheckDateBox: [],
                isTouchable: false,
                keyboardValue: false,
            };
        },
        mounted() {
            let tempthis = this;

            window.addEventListener("click", function (e) {
                if (document.getElementById("keyboardId")?.contains(e.target)) {
                    tempthis.keyBoardToggle(true);
                } else if (
                    document.getElementById("keyboardTextField")?.contains(e.target)
                ) {
                    tempthis.keyBoardToggle(true);
                } else {
                    tempthis.keyBoardToggle(false);
                }
            });

            this.isTouchable =
                "ontouchstart" in window || navigator.maxTouchPoints > 0;
        },
        methods: {
            keyBoardToggle(value) {
                this.keyboardValue = value;
            },

            onKeyboardChange(input) {
                this.searchInput = input;
                this.currentPage = 1;
            },

            onKeyPress: debounce(function (button) {
                switch (button) {
                    case "{enter}":
                        this.keyBoardToggle(false);
                        break;
                }
            }, 100),

            singleUserData(personData) {
                this.selectedPersonData = { ...personData };
                this.selected = personData.id;
                this.getPersonAwards({
                    personName: personData.name,
                    onSuccess: () => {
                        this.openModal = !this.openModal;
                    },
                });
            },

            toggle() {
                this.openModal = !this.openModal;
                this.selected = "";
            },
            onModalHidden() {
                this.selected = "";
            },

            checkfunc(checkboxValue) {
                let index = this.golfClubData.awards.findIndex(
                    (obj) => obj.name == checkboxValue
                );
                if (index != -1) {
                    if (
                        this.selectedCheckBox.some(
                            (obj) => obj.start == checkboxValue
                        )
                    ) {
                        this.selectedCheckBox = this.selectedCheckBox.filter(
                            (value) => value.start !== checkboxValue
                        );
                    } else {
                        this.selectedCheckBox.push({ start: checkboxValue });
                    }
                }
            },

            checkDatefunc(checkboxValue) {
                let filterobj = this.dataRange.find(
                    (obj) => obj.start == checkboxValue
                );
                if (filterobj) {
                    if (
                        this.selectedCheckDateBox.some(
                            (obj) => obj.start == filterobj.start
                        )
                    ) {
                        this.selectedCheckDateBox =
                            this.selectedCheckDateBox.filter(
                                (value) => value.start !== filterobj.start
                            );
                    } else {
                        this.selectedCheckDateBox.push({
                            start: filterobj.start,
                            end: filterobj.end,
                        });
                    }
                }
            },
            applyFilters(person) {
                if (this.selectedCheckDateBox.length === 0 && this.selectedCheckBox.length === 0) return true;

                const personAward = this.golfClubData.awards.find(award => award.id === person.award);
                const dateFilterValid = this.selectedCheckDateBox.length === 0 ||
                    this.selectedCheckDateBox.some(filter => filter.start <= person.date && filter.end >= person.date);
                const checkboxFilterValid = this.selectedCheckBox.length === 0 ||
                    (personAward && this.selectedCheckBox.some(filter => filter.start === personAward.name));

                return dateFilterValid && checkboxFilterValid;
            }
        },
        computed: {
            calculateDateRanges() {
                const personsByYearRange = [];
                this.golfClubData?.awards?.forEach(award =>
                    award.persons.forEach(person => {
                        const yearGroup = Math.floor(parseInt(person.date) / 5) * 5;
                        const range = personsByYearRange.find(r => r.start === yearGroup);
                        range ? range.person++ : personsByYearRange.push({ start: yearGroup, end: yearGroup + 4, person: 1 });
                    })
                );
                personsByYearRange.sort((a, b) => a.start - b.start);
                this.dataRange = personsByYearRange;
                return personsByYearRange;
            },

            communityDetails() {
                if (!this.golfClubData) return {};
                return {
                    imageFile: this.golfClubData?.backgroundImage,
                    name: this.golfClubData?.name,
                    extra: this.golfClubData?.info,
                };
            },

            filteredResults() {
                if (!this.golfClubData || !this.golfClubData.awards || !this.searchInput) return [];

                const allPersons = this.golfClubData.awards.flatMap(award =>
                    award.persons?.filter(person => {
                        const matchesSearch = person.name.toLowerCase().includes(this.searchInput.toLowerCase());
                        const passesFilters = this.applyFilters(person);
                        return matchesSearch && passesFilters;
                    }) || []
                );

                // Deduplicate persons by name, keeping the first occurrence
                const uniquePersons = [];
                const seenNames = new Set();

                allPersons.forEach(person => {
                    if (!seenNames.has(person.name)) {
                        seenNames.add(person.name);
                        uniquePersons.push(person);
                    }
                });

                return uniquePersons;
            },
            paginatedResults() {
                const start = (this.currentPage - 1) * this.pageSize;
                return this.filteredResults.slice(start, start + this.pageSize);
            },
            totalPages() {
                return this.filteredResults.length ? Math.ceil(this.filteredResults.length / this.pageSize) : 1;
            },
        },

        watch: {
            searchInput: debounce(function() {
                if (!this.searchInput) {
                    this.selectedCheckBox = [];
                    this.selectedCheckDateBox = [];
                }
                this.currentPage = 1;
            }, 300),
            selectedCheckBox() {
                this.currentPage = 1;
            },
            selectedCheckDateBox() {
                this.currentPage = 1;
            },
        }
    };
</script>

<style lang="scss">
.pagination-controls {
    button {
        padding: 0.5rem 1rem;
    }
    button:disabled {
        opacity: 0.5;
    }
}
</style>